import { render, staticRenderFns } from "./Class4.vue?vue&type=template&id=26fde0a3&"
import script from "./Class4.vue?vue&type=script&lang=js&"
export * from "./Class4.vue?vue&type=script&lang=js&"
import style0 from "./Class4.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports